import { render, staticRenderFns } from "./EventUpdate.vue?vue&type=template&id=5f25cc60&scoped=true&"
import script from "./EventUpdate.vue?vue&type=script&lang=js&"
export * from "./EventUpdate.vue?vue&type=script&lang=js&"
import style0 from "./EventUpdate.vue?vue&type=style&index=0&id=5f25cc60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f25cc60",
  null
  
)

export default component.exports